import React, { useState, useEffect } from 'react';

import { POI_VIEW_ID_MOBILE } from './constants.ts';
import HandlerContext from './handlerContext.tsx';
import PoiViewWidgetDesktop from './poiViewWidgetDesktop.tsx';
import PoiViewWidgetMobile from './poiViewWidgetMobile.tsx';

const PoiView = ({ bus, widgetState, isDesktop, T, lang }) => {
  const [state, setState] = useState(widgetState.getState());

  useEffect(() => widgetState.addCallback(setState), [widgetState]);

  const submitAnalyticsEvent = (poi, actionType, actionValue) =>
    bus.send('events/externalAction', { poi, actionType, actionValue });
  const submitAnalyticsEventWithAppInsights = (poi, actionType, actionValue) => {
    submitAnalyticsEvent(poi, actionType, actionValue);
    bus.send('appInsights/log', {
      name: 'poiView/informationLinkClick',
      properties: { poiId: poi.poiId, actionValue },
    });
  };
  const submitReserveParkingClick = (poi, bookingLink) => {
    submitAnalyticsEvent(poi, 'reserveParking', bookingLink);
    bus.send('appInsights/log', {
      name: 'poiView/reserveParkingClick',
      properties: { poiId: poi.poiId, actionValue: bookingLink },
    });
  };

  const {
    poi,
    layout,
    venueCategory,
    venueTimezone,
    structures,
    searchInputsLength,
    hidePoiFeedback,
    venueId,
    openStatus,
  } = state;

  return isDesktop() ? (
    <PoiViewWidgetDesktop
      poi={poi}
      structures={structures}
      layout={layout}
      T={T}
      venueCategory={venueCategory}
      venueTimezone={venueTimezone}
      openStatus={openStatus}
      lang={lang}
      submitAnalyticsEvent={submitAnalyticsEvent}
      submitAnalyticsEventWithAppInsights={submitAnalyticsEventWithAppInsights}
      submitReserveParkingClick={submitReserveParkingClick}
      searchInputsLength={searchInputsLength}
      hidePoiFeedback={hidePoiFeedback}
      venueId={venueId}
    />
  ) : (
    <PoiViewWidgetMobile
      id={POI_VIEW_ID_MOBILE}
      poi={poi}
      structures={structures}
      layout={layout}
      T={T}
      bus={bus}
      venueCategory={venueCategory}
      venueTimezone={venueTimezone}
      openStatus={openStatus}
      lang={lang}
      submitAnalyticsEvent={submitAnalyticsEvent}
      submitAnalyticsEventWithAppInsights={submitAnalyticsEventWithAppInsights}
      submitReserveParkingClick={submitReserveParkingClick}
      searchInputsLength={searchInputsLength}
      hidePoiFeedback={hidePoiFeedback}
      venueId={venueId}
    />
  );
};

const PoiViewWidget = ({ app, handlers, widgetState }) => (
  <HandlerContext.Provider value={handlers}>
    <PoiView
      bus={app.bus}
      widgetState={widgetState}
      T={app.gt()}
      isDesktop={app.env.isDesktop}
      lang={app.i18n().language}
    />
  </HandlerContext.Provider>
);

export default PoiViewWidget;
